import { MouseEvent } from "react";

import {
  AutocompleteOptionType,
  LoadingSpinner,
} from "chameleon/lib/components";
import { AutocompleteOption } from "chameleon/lib/components/dropdown-autocomplete/autocomplete-option";
import {
  dropdownContainerLiClass,
  dropdownContainerLiHighlightClass,
} from "chameleon/lib/components/dropdown-autocomplete/dropdown-autocomplete.css";

interface Props {
  options: AutocompleteOptionType[];
  loading: boolean;
  cursor: number;
  handleMouseOver: (index: number) => void;
  handleSelectItem: (
    e: MouseEvent<HTMLLIElement>,
    option: AutocompleteOptionType
  ) => void;
  id: string;
}

export const AutocompleteOptionsList = ({
  options,
  loading,
  cursor,
  handleMouseOver,
  handleSelectItem,
  id,
}: Props) => {
  if (loading) {
    return (
      <div aria-busy="true" role="alert">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <>
      {options.map((option, index) => (
        <li
          tabIndex={0}
          key={option.value}
          onMouseOver={() => handleMouseOver(index)}
          onMouseDown={(e) => handleSelectItem(e, option)}
          className={`${dropdownContainerLiClass} ${
            index === cursor ? dropdownContainerLiHighlightClass : ""
          }`}
          role="option"
          data-testid={`${id}-item${index === cursor && "-selected"}`}
          data-dd-privacy="mask"
        >
          <AutocompleteOption prediction={option.prediction} />
        </li>
      ))}
    </>
  );
};
